import { css } from '@emotion/react';
import {
  type ComponentProps, type PropsWithChildren,
} from 'react';
import type { Theme } from '~/_shared/themes/theme.model';
import {
  type ActiveBoundaryFillDropdownProps, ActiveBoundaryFillHeader,
} from '~/sidebar/sidebarApps/mapTools/boundary/activeBoundary/activeBoundaryFillIHeader';
import { ActiveDataLayerToolbarComponent } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/listing/activeDataLayerToolbar.component';
import { BoundaryKeyHeaderInfoComponent } from '~/sidebar/sidebarApps/rightSidebar/masterKey/boundaryKey/BoundaryKeyHeaderInfo.component';
import type { DataLayer } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.state';

const headerActionsWrapperStyle = (theme: Theme) => css({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.backgroundColors.secondary,
  boxSizing: 'border-box',
  padding: '5px 10px 5px 16px',
});

const headerToolbarWrapperStyle = css({
  minHeight: 34,
});

const subheaderStyle = (theme: Theme) => css({
  backgroundColor: theme.backgroundColors.highlight,
  boxSizing: 'border-box',
  fontSize: 14,
  paddingBlock: 4,
  paddingInline: 12,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: 8,
  userSelect: 'none',
  minHeight: 32,
});

export const ActiveDataLayerComponent = ({
  boundaryGroupName,
  children,
  dataLayer,
  dropdownProps,
  toolbarProps,
}: PropsWithChildren<Readonly<{
  boundaryGroupName?: string;
  dataLayer: DataLayer;
  toolbarProps: ComponentProps<typeof ActiveDataLayerToolbarComponent>;
  dropdownProps: ActiveBoundaryFillDropdownProps;
}>>) => {
  return (
    <div>
      <ActiveBoundaryFillHeader
        dropdownProps={dropdownProps}
      />
      <div css={subheaderStyle}>
        <BoundaryKeyHeaderInfoComponent
          shortenedSubEntity={dataLayer.data.title}
          boundaryTerritoryGroupName={boundaryGroupName}
        />
      </div>
      <div css={headerActionsWrapperStyle}>
        <div />
        <div css={headerToolbarWrapperStyle}>
          <ActiveDataLayerToolbarComponent {...toolbarProps} />
        </div>
      </div>
      {children}
    </div>
  );
};
